import { render } from "./BillingSettings.vue?vue&type=template&id=2b58f3fd"
import script from "./BillingSettings.vue?vue&type=script&lang=js"
export * from "./BillingSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/BillingSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b58f3fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b58f3fd', __exports__)) {
    api.reload('2b58f3fd', __exports__)
  }
  
  module.hot.accept("./BillingSettings.vue?vue&type=template&id=2b58f3fd", () => {
    api.rerender('2b58f3fd', render)
  })

}


export default __exports__